import HouseType from '../houseType';
import RoomObject from '../room';
export default class Apartment_1_room extends HouseType {
  constructor() {
    super();
    this.id = 'apartment';
    this.name = "1-roms Leilighet";
    this.icon = "mdi-home-city";

    this.defaultRooms = [
      new RoomObject('Entry'),
      new RoomObject('Livingroom'),
      new RoomObject('Kitchen'),
      new RoomObject('Bathroom')
    ];
  }
}